var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5156 6.03906L6.76562 9.78906C6.48438 10.0938 5.99219 10.0938 5.71094 9.78906C5.40625 9.50781 5.40625 9.01562 5.71094 8.73438L8.17188 6.25H1C0.578125 6.25 0.25 5.92188 0.25 5.5C0.25 5.10156 0.578125 4.75 1 4.75H8.17188L5.71094 2.28906C5.40625 2.00781 5.40625 1.51562 5.71094 1.23438C5.99219 0.929688 6.48438 0.929688 6.76562 1.23438L10.5156 4.98438C10.8203 5.26562 10.8203 5.75781 10.5156 6.03906Z",
    fill: "#111113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/IconArrowRight.b8fccdb5e3ac1dcb82f14e11b0215386.svg";
export { ForwardRef as ReactComponent };